
import axios from "axios";
// import {jwtDecode} from "jwt-decode";
import { decryptionData } from '@/components/utils/utils.js';
import Notification from  '@/components/Notification';
import { mapGetters } from 'vuex';
  export default {
    components: {
      Notification: Notification
    },
    data () {
      return {
      tableLoading : false,
        type_delete:"",
        action_btn:"",
        isCommaError: [], // Status error koma
        datatable: [],
        dialogDelete: false,
        search:'',
        collect_news_val: true,
        collect_twit_val: true,
        collect_ig_val: true,
        collect_tiktok_val: true,
        collect_ytb_val: true,
        collect_fb_val: true,
        dialogPinnsed:false,
        pinned_id: '',
        person_id: '',
        name_action_dialog: '',
        item_account_news: [
          {account : '',id_account : '',collection: ''}
        ],
        
        item_account_twet: [
          {account : '',id_account : '',collection: ''}
        ],
        
        item_account_ig: [
          {account : '',id_account : '',collection: ''}
        ],
        
        item_account_tiktok: [
          {account : '',id_account : '',collection: ''}
        ],
        
        item_account_youtube: [
          {account : '',id_account : '',collection: ''}
        ],

        item_account_facebook: [
          {account : '',id_account : '',collection: ''}
        ],
        btnload:false,
        alertSuccess:'',
        alertFailed:'',
        alert_err_attention: "",
        text_delete:"",
        isAdd: false,
        uniqueId: "",
        addvalPinned: "",
        valueAddAccount:[],
        account: "",
        listAccount: [
          {
            name: '', 
            valueperson: '',
            subtitle:''
          }
        ],
        
        brandCategory_id: "",
        branchCategoryIdrules: [
            v => !!v || 'Branch Category is required',
          ],
        listBrand: [
          {
            name: '', 
            valuea: ''
          }
        ],
        analysis_id: "",
        analisisIdrules: [
            v => !!v || 'Group Analisis is required',
          ],
        listAnalysis: [
          {
            name: '', 
            valueanalysis: ''
          }
        ],
        
        resultAccount: [],
        resultAccountWithId: [],
        resultrealAccount:[],
        indexDelete: [],
        chip1: true,
        chip2: true,
        chip3: true,
        chip4: true,
      }
    },
    computed: {
      page() {
        return this.$store.state.breadcrumbs
      },
      ...mapGetters(['navbarWithName']), // Accessing navbarWithName from Vuex
       // Dynamically determine which headers to show
      dynamicHeaders() {
        // Define the base headers
        const baseHeaders = [
          { text: 'Group Analysis', value: 'GROUP_ANALYSIS' },
          { text: 'User Display Name', value: 'USER_DISPLAY_NAME' },
          { text: 'News', value: 'NEWS' },
          { text: 'Twitter', value: 'TWITTER' },
          { text: 'Instagram', value: 'INSTAGRAM' },
          { text: 'Tik Tok', value: 'TIKTOK' },
          { text: 'Youtube', value: 'YOUTUBE' },
          { text: 'Facebook', value: 'FACEBOOK' },
          { text: 'Brand Category', value: 'NAME_CATEGORY' },
          { text: 'Actions', value: 'actions', sortable: false }
        ];

        // Filter out the Instagram and YouTube columns if they are not active
        let filteredHeaders = baseHeaders;

        if (this.collect_news_val  == false) {
          filteredHeaders = filteredHeaders.filter(header => header.value !== 'NEWS');
        }
        
        if (this.collect_twit_val  == false) {
          filteredHeaders = filteredHeaders.filter(header => header.value !== 'TWITTER');
        }
        if (this.collect_ig_val == false) {
          filteredHeaders = filteredHeaders.filter(header => header.value !== 'INSTAGRAM');
        }
        if (this.collect_tiktok_val == false) {
          filteredHeaders = filteredHeaders.filter(header => header.value !== 'TIKTOK');
        }

        if (this.collect_ytb_val  == false) {
          filteredHeaders = filteredHeaders.filter(header => header.value !== 'YOUTUBE');
        }

        if (this.collect_fb_val  == false) {
          filteredHeaders = filteredHeaders.filter(header => header.value !== 'FACEBOOK');
        }
        return filteredHeaders;
      }
    },
    mounted(){
      this.getResultAccount()
      // this.initialize()

    },
    
    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
    },
    methods:{   
      blockComma(event, index,source) {
        // 188 adalah kode untuk koma (',')
        if (event.keyCode === 188) {
          event.preventDefault();  // Mencegah input koma
          // this.$set(this.isCommaError, index, true);  // Set error untuk index ini
          this.$set(this.isCommaError, index, { ...this.isCommaError[index], [source]: true });
          setTimeout(() => {
            this.$set(this.isCommaError, index, { ...this.isCommaError[index], [source]: false });
          }, 3000);
        }else{
          // this.isCommaError[index] = false;
          // this.$set(this.isCommaError, index, false);  // Set error untuk index ini
          this.$set(this.isCommaError, index, { ...this.isCommaError[index], [source]: false });

        }
      },

      // Fungsi untuk menangani event paste
      handlePaste(event, index,source) {
        const pastedText = event.clipboardData.getData('text');  // Ambil teks yang dipaste
        if (pastedText.includes(',')) {
          event.preventDefault();  // Batalkan paste jika ada koma
          this.$set(this.isCommaError, index, { ...this.isCommaError[index], [source]: true });
          setTimeout(() => {
            this.$set(this.isCommaError, index, { ...this.isCommaError[index], [source]: false });
          }, 3000);
        }
      },
      async getResultAccount(){      
          axios.get("pinned_account",
            { headers:{'auth-token':localStorage.getItem('token_app')}},
            {dataType: 'json'}
            ).then((response) => {
              let res = decryptionData(response.data.token);
              let data_encript = res.data;
              this.datatable = res.data_table;
            this.collect_news_val = res.collection_news;
            this.collect_twit_val = res.collection_twitter;
            this.collect_ig_val = res.collection_instagram;
            this.collect_tiktok_val = res.collection_tiktok;
            this.collect_ytb_val = res.collection_ytb;
            this.collect_fb_val = res.collection_facebook;


              // console.log(res.collection_news)
              let resultpin = '';
              let colorpin = '';
              this.resultAccountWithId =[]
              if(data_encript.pinned.length > 0){
                for (let i = 0; i <  data_encript.pinned.length; i++) {  
                  if(data_encript.pinned[i].USER_TYPE === 0){
                    colorpin = '';
                  }
                  if(data_encript.pinned[i].USER_TYPE === 1){
                    colorpin = 'primary';
                  }
                  if(data_encript.pinned[i].USER_TYPE === 2){
                    colorpin = 'error';
                  }
                  resultpin = {
                      SEQ_ID : data_encript.pinned[i].SEQ_ID,
                      PERSON_ID  : data_encript.pinned[i].PERSON_ID,
                      GROUP_ID  : data_encript.pinned[i].GROUP_ID,
                      USER_ID  : data_encript.pinned[i].USER_ID,
                      USER_DISPLAY_NAME  : data_encript.pinned[i].USER_DISPLAY_NAME,
                      
                      COLOR  : colorpin
                    };
                    
                    this.resultAccountWithId.push(resultpin);
                }
              }

              let result = '';
              // let resultpromp = '';
              let type = '';
              let arr_data_person = [];
              if(data_encript.peson_select.length > 0){
                for (let i = 0; i <  data_encript.peson_select.length; i++) {  
                    if(i == 1){
                      this.peson_select_id = (data_encript.peson_select[i].SEQ_ID);
                    }
                    
                    if(data_encript.peson_select[i].USER_TYPE == 0){
                      type = 'News';
                    }else if(data_encript.peson_select[i].USER_TYPE == 1){
                      type = 'Twetter';
                    }else{
                      type = 'Youtube';
                    }
                    result = {
                      valueperson : data_encript.peson_select[i].SEQ_ID,
                      name  : data_encript.peson_select[i].USER_DISPLAY_NAME,
                      subtitle  : type
                    };
                    arr_data_person.push(result);
                }
                this.listAccount= arr_data_person;
              }

              let resultanalysis = '';
              let arr_data_analysis = [];
              if(data_encript.analysis_select.length > 0){
                for (let i = 0; i <  data_encript.analysis_select.length; i++) {  
                    resultanalysis = {
                      valueanalysis : data_encript.analysis_select[i].SEQ_ID,
                      name  : data_encript.analysis_select[i].GROUP_ANALYSIS
                    };
                    arr_data_analysis.push(resultanalysis);
                }
                this.listAnalysis= arr_data_analysis;
              }


              let resultbrandCategory = '';
              let arr_data_brandCategory = [];
              if(data_encript.category_select.length > 0){
                for (let i = 0; i <  data_encript.category_select.length; i++) {  
                    resultbrandCategory = {
                      valueBrand : data_encript.category_select[i].SEQ_ID,
                      name  : data_encript.category_select[i].NAME_CATEGORY
                    };
                    arr_data_brandCategory.push(resultbrandCategory);
                }
                this.listBrand= arr_data_brandCategory;
              }

              


              this.resultAccount = data_encript.peson_select    
              this.isAdd = false
            })
            .catch((e) => {
                switch (e.response.status) {
                    case 404:
                          this.$refs.alert.error_login(404);
                        break;
                    case 403:
                          this.$refs.alert.error_login(403);
                        break;
                    default:
                        console.log('some other error');  // end up here all the time
                        break;
                }
            console.log(e)
          });  
      },  
      addResultAccount(){
        this.pinned_id = ""
        
        if(this.account == ''){ 
          this.alertFailed = true;
          this.alert_err_attention =  "Person has been add" ;
        }else if(this.resultAccount.includes(this.account)){
          this.alertFailed = true;
          this.alert_err_attention =  "Account has been add" ;
        }else {
          this.resultAccount.forEach((element) => {
            // var color ="";
            if(element["SEQ_ID"] == this.account){

              this.resultAccountWithId.forEach((elm) => {
                if(elm["PERSON_ID"] == this.account){
                this.addvalPinned = -1
                }else{

                  this.addvalPinned = 1
                }
              });
              if(this.addvalPinned == -1){

                this.alertFailed = true;
                  this.alert_err_attention =  "Account has been exist" ;
              }else{
                  axios({
                    method: "put",
                    url: "get-pinned-history",
                    data: {
                      id: element['SEQ_ID']
                    },
                    headers:{'auth-token':localStorage.getItem('token_app')},
                    dataType: 'json'
                  }).then((response) => {
                      let result = decryptionData(response.data.token);
                      
                      const alias = result.alias_person;
                      this.item_account_news =[];
                      
                      if(alias.length > 0){
                        for (let i = 0; i <  alias.length; i++) { 
                          this.item_account_news.push({account: alias[i].NER_ALIAS ,id_account: alias[i].SEQ_ID ,collection: this.collect_news_val});
                        }
                      }else{
                        this.item_account_news =[];
                        this.item_account_news.push({ account : '',id_account : '',collection: this.collect_news_val })
                      }
            

                        // ======end history === 
                      const history = result.data_history;
                      this.action_btn = 'add';

                      if( history != undefined){
                        this.pinned_id = history.SEQ_ID

                        let twittArray = history.TWITTER.split(',').map(item => item.trim());  // Menambahkan trim untuk menghapus spasi ekstra
                        this.item_account_twet = [];
                        twittArray.forEach(data => {
                            this.item_account_twet.push({
                                account: data,
                                id_account: '',
                                collection: this.collect_twit_val
                            });
                        });
              
                        let igArray = history.INSTAGRAM.split(',').map(item => item.trim());  // Menambahkan trim untuk menghapus spasi ekstra
                        this.item_account_ig = [];
                        igArray.forEach(data => {
                            this.item_account_ig.push({
                                account: data,
                                id_account: '',
                                collection: this.collect_ig_val
                            });
                        });
                        
                        let tiktokArray = history.TIKTOK.split(',').map(item => item.trim());  // Menambahkan trim untuk menghapus spasi ekstra
                        this.item_account_tiktok = [];
                        tiktokArray.forEach(data => {
                            this.item_account_tiktok.push({
                                account: data,
                                id_account: '',
                                collection: this.collect_tiktok_val
                            });
                        });
                        
            
                        let ytbArray = history.YOUTUBE.split(',').map(item => item.trim());  // Menambahkan trim untuk menghapus spasi ekstra
                        this.item_account_youtube = [];
                        ytbArray.forEach(data => {
                            this.item_account_youtube.push({
                                account: data,
                                id_account: '',
                                collection: this.collect_ytb_val
                            });
                        });


                        let fbArray = history.FACEBOOK.split(',').map(item => item.trim());  // Menambahkan trim untuk menghapus spasi ekstra
                        this.item_account_facebook = [];
                        fbArray.forEach(data => {
                            this.item_account_facebook.push({
                                account: data,
                                id_account: '',
                                collection: this.collect_fb_val
                            });
                        });

                        
                        // ======end history === 
                      }else{
                        this.pinned_id = ""

                        this.item_account_twet =[];
                        this.item_account_twet.push({ account : '',id_account : '',collection: this.collect_twit_val })
            
                        this.item_account_ig =[];
                        this.item_account_ig.push({ account : '',id_account : '',collection: this.collect_ig_val })

                        
                        this.item_account_tiktok =[];
                        this.item_account_tiktok.push({ account : '',id_account : '',collection: this.collect_tiktok_val })
                        
                        this.item_account_youtube =[];
                        this.item_account_youtube.push({ account : '',id_account : '',collection: this.collect_ytb_val })


                        this.item_account_facebook =[];
                        this.item_account_facebook.push({ account : '',id_account : '',collection: this.collect_fb_val })
                    
                      }
                      
                      this.person_id = element['SEQ_ID']
                      this.name_action_dialog = element['USER_DISPLAY_NAME']
                      
                      this.dialogPinnsed = true

                  })
                  .catch((e) => {
                      switch (e.response.status) {
                          case 404:
                                this.$refs.alert.error_login(404);
                              break;
                          case 403:
                                this.$refs.alert.error_login(403);
                              break;
                          default:
                              console.log('some other error');  // end up here all the time
                              break;
                      }
                  console.log(e)
                }); 

              }

            }
          })



        }
      },
      valueAccount(account){  
        const uuidv4 = require('uuid/v4');     
        this.uniqueId = uuidv4()
        console.log(account);
      },
      closeChip(item,type){ 

        this.type_delete = type
        this.pinned_id = item.SEQ_ID
        this.dialogDelete = true
        this.text_delete = "list detail pinned and pinned account"

        if(type == 'pin'){
          this.text_delete = "pinned account"
        }
      },
      
      deleteItemConfirm(){ 
        this.indexDelete.push(this.pinned_id)
        this.isAdd = true  
          let url = "/pinned-history/delete"
          if(this.type_delete == 'pin'){
              url = "/pinned-account/delete"
          }
          axios({
            method: "delete",
            url: url,
            data: {
              id_pinned: this.pinned_id
            },
            headers:{'auth-token':localStorage.getItem('token_app')},
            dataType: 'json'
          })
          .then((response) => {
            // handle success
              var status = response.data.status
              var messages = response.data.msg
              if(status == 200){
                this.getResultAccount()
                this.alertSuccess = true;
                this.alert_err_attention =  messages;

              }else{
                  this.alertFailed = true;
                  this.alert_err_attention =  messages;
              } 
              this.dialogDelete = false

          })
          .catch(function (error) {
            this.dialogDelete = false

            this.alertFailed = true;
            this.alert_err_attention =  'Delete Failed '+error;
          })
          this.resultAccountWithId = removeObjectWithId(this.resultAccountWithId, this.pinned_id);
    
        function removeObjectWithId(arr, id) {
        return arr.filter((obj) => obj.SEQ_ID !== id);
        }
      },
      
      
      closeDelete () {
        this.dialogDelete = false
        this.pinned_id = ""
        this.action_btn = ""
      },
      async postAccount(){
        const isValid = this.$refs.form.validate();
        if (isValid) {

          this.btnload = true
          if(this.person_id != "" || this.isAdd == true){
            axios.post("/pinned_account/action", 
            {
                action : this.action_btn,
                brand_category_id :this.brandCategory_id,
                analysis_id :this.analysis_id,
                pinned_id :this.pinned_id,
                person_id :this.person_id,
                account_news :this.item_account_news,
                account_twet :this.item_account_twet,
                account_ig :this.item_account_ig,
                account_tiktok :this.item_account_tiktok,
                account_youtube :this.item_account_youtube,
                account_facebook :this.item_account_facebook,
              },
              { headers:{'auth-token':localStorage.getItem('token_app')}},
              {dataType: 'json'}
              )
            .then((response) => {
                var status = response.data.status
                var messages = response.data.msg
                if(status == 200){
                  this.getResultAccount();
                  this.alertSuccess = true;
                  this.alert_err_attention =  messages;
                  this.btnload = false
                  this.close();
                }else{
                    this.alertFailed = true;
                    this.alert_err_attention =  messages;
                    this.btnload = false
                } 
              })
            .catch((e) => {
                  switch (e.response.status) {
                      case 404:
                            this.$refs.alert.error_login(404);
                          break;
                      case 403:
                            this.$refs.alert.error_login(403);
                          break;
                      case 400:
                            this.alertFailed = true;
                            this.alert_err_attention =  e.response.data.msg;
                            this.btnload = false
                          break;
                      default:
                          console.log('some other error');  // end up here all the time
                          break;
                      }
              this.errors=e.response.data.msg;
            });   
          }else{
              this.alertFailed = true;
              this.alert_err_attention =  "Account has not been added" ;
              this.btnload = false
          }  
        }              
      },
      
      updateAccount (item) {
        this.action_btn = 'update';
        axios({
          method: "put",
          url: "pinned_account_id",
          data: {
            seq_id: item.SEQ_ID,
            person_id: item.PERSON_ID
          },
          headers:{'auth-token':localStorage.getItem('token_app')},
          dataType: 'json'
        })
        .then((response) => {
            // console.log(response.data);
            let result = decryptionData(response.data.token);
            
            const alias = result.alias_person;
            
            this.analysis_id =result.analysis_id;
            this.brandCategory_id =result.brand_category_id;
            this.item_account_news =[];
            
            if(alias.length > 0){
              for (let i = 0; i <  alias.length; i++) { 
                this.item_account_news.push({account: alias[i].NER_ALIAS ,id_account: alias[i].SEQ_ID ,collection: this.collect_news_val});
              }
            }else{
              this.item_account_news =[];
              this.item_account_news.push({ account : '',id_account : '',collection: this.collect_news_val })
            }

            let twittArray = item.TWITTER.split(',').map(item => item.trim());  // Menambahkan trim untuk menghapus spasi ekstra
            this.item_account_twet = [];
            twittArray.forEach(data => {
                this.item_account_twet.push({
                    account: data,
                    id_account: '',
                    collection: this.collect_twit_val
                });
            });
  
            let igArray = item.INSTAGRAM.split(',').map(item => item.trim());  // Menambahkan trim untuk menghapus spasi ekstra
            this.item_account_ig = [];
            igArray.forEach(data => {
                this.item_account_ig.push({
                    account: data,
                    id_account: '',
                    collection: this.collect_ig_val
                });
            });
            
            let tiktokArray = item.TIKTOK.split(',').map(item => item.trim());  // Menambahkan trim untuk menghapus spasi ekstra
            this.item_account_tiktok = [];
            tiktokArray.forEach(data => {
                this.item_account_tiktok.push({
                    account: data,
                    id_account: '',
                    collection: this.collect_tiktok_val
                });
            });
            
            let ytbArray = item.YOUTUBE.split(',').map(item => item.trim());  // Menambahkan trim untuk menghapus spasi ekstra
            this.item_account_youtube = [];
            ytbArray.forEach(data => {
                this.item_account_youtube.push({
                    account: data,
                    id_account: '',
                    collection: this.collect_ytb_val
                });
            });
  
            
            let fbArray = item.FACEBOOK.split(',').map(item => item.trim());  // Menambahkan trim untuk menghapus spasi ekstra
            this.item_account_facebook = [];
            fbArray.forEach(data => {
                this.item_account_facebook.push({
                    account: data,
                    id_account: '',
                    collection: this.collect_fb_val
                });
            });
  

            this.pinned_id = item.PINNED_PERSON_ID
            this.person_id = item.PERSON_ID
            this.name_action_dialog = item.USER_DISPLAY_NAME
            this.dialogPinnsed = true
            
            
        })
        .catch(function (error) {
          // handle error
          console.log(error);
        })
      },
      add_news() {
        this.item_account_news.push({ account: '' ,id_account: '', collection: '' })
      },
      
      remove_news(item, index) {
        if(index > 0){
          this.item_account_news.splice(index, 1)
        }else{
          this.alertFailed = true;
          this.alert_err_attention =  "The First Line cannot be deleted" ;
        }
      },
      add_tweet() {
        this.item_account_twet.push({ account: '' ,id_account: '', collection: this.collect_twit_val })
      },
        
      
      remove_tweet(item, index) {
        if(index > 0){
          this.item_account_twet.splice(index, 1)
        }else{
          this.alertFailed = true;
          this.alert_err_attention =  "The First Line cannot be deleted" ;
        }
      },
      
      add_ig() {
        this.item_account_ig.push({ account: '' ,id_account: '', collection: this.collect_ig_val })
      },
        
      
      remove_ig(item, index) {
        if(index > 0){
          this.item_account_ig.splice(index, 1)
        }else{
          this.alertFailed = true;
          this.alert_err_attention =  "The First Line cannot be deleted" ;
        }
      },
      
      add_tiktok() {
        this.item_account_tiktok.push({ account: '' ,id_account: '', collection: this.collect_tiktok_val })
      },
        
      remove_tiktok(item, index) {
        if(index > 0){
          this.item_account_tiktok.splice(index, 1)
        }else{
          this.alertFailed = true;
          this.alert_err_attention =  "The First Line cannot be deleted" ;
        }
      },
      
      add_youtube() {
        
        this.item_account_youtube.push({ account: '' ,id_account: '', collection: this.collect_ytb_val })
      },
        
      remove_youtube(item, index) {
        if(index > 0){
          this.item_account_youtube.splice(index, 1)
        }else{
          this.alertFailed = true;
          this.alert_err_attention =  "The First Line cannot be deleted" ;
        }
      },


      add_facebook() {
        
        this.item_account_facebook.push({ account: '' ,id_account: '', collection: this.collect_fb_val })
      },
        
      remove_facebook(item, index) {
        if(index > 0){
          this.item_account_facebook.splice(index, 1)
        }else{
          this.alertFailed = true;
          this.alert_err_attention =  "The First Line cannot be deleted" ;
        }
      },
      close () {
        this.person_id =""
        this.action_btn = ""
        this.pinned_id = ""

        this.item_account_news =[];
        this.item_account_news.push({ account : '',id_account : '',collection: this.collect_news_val })

        this.item_account_twet =[];
        this.item_account_twet.push({ account : '',id_account : '',collection: this.collect_twit_val })

        this.item_account_ig =[];
        this.item_account_ig.push({ account : '',id_account : '',collection: this.collect_ig_val })

        this.item_account_tiktok =[];
        this.item_account_tiktok.push({ account : '',id_account : '',collection: this.collect_tiktok_val })
        
        this.item_account_youtube =[];
        this.item_account_youtube.push({ account : '',id_account : '',collection: this.collect_youtube_val })

        this.item_account_facebook =[];
        this.item_account_facebook.push({ account : '',id_account : '',collection: this.collect_fb_val })

        this.isAdd = false  
        
        this.dialogPinnsed = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },
      openSettingGroupAnalysis() {
        this.$router.push('/SettingGroupAnalysis')
      },
    }
  }